import React from "react";

export default (params) => {
  return (
    <a 
      href={params.value} 
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: '#0066cc',
        textDecoration: 'underline',
        cursor: 'pointer'
      }}
    >
      Download File
    </a>
  );
};
